export interface FlagConfig {
  dateAdded: string;
  launchDarklyUrl: string;
  flagDependencies: FlagKey[]; // these are the flags that this flag depends on to be considered "on"
  description?: string;
  cleanupNotes?: string;
  fallbackFlagValue: boolean;
}

/**
  @description - Used to give details regarding each flag and used within useFlag custom hook to determine what flags exist for checking the flag's value
  // ! Make sure to set each flag config as its own variable with the type FlagConfig before adding to launchDarklyConfig
  @notes - unable to add type to launchDarklyConfig as the type needs to be inherited when making union type of keys (FlagKey type)
*/

const kacp22367DeploymentEnhancements: FlagConfig = {
  dateAdded: "07/28/2026",
  launchDarklyUrl: "https://app.launchdarkly.com/dataknox-erp/test/features/kacp-22367-deployment-enhancements/targeting",
  flagDependencies: [],
  fallbackFlagValue: false,
  description:
    "KACP-22367 Deployment Enhancements epic. Gates: (1) Sales Order Load from Location performance - batched asset fetching and parallel line item creation/allocation, off = original sequential loop; (2) the Deployment Load from Location feature (button + modal on the Deployment Line Items tab).",
  cleanupNotes:
    "When permanently enabled: in SalesOrder lineItems delete the legacy generateHandleCreateLineItemsFromSelectedAssets generator (helpers.tsx) and its interface (types.ts), always use generateHandleCreateLineItemsFromSelectedAssetsInParallel in LoadFromLocationModel.tsx (drop the flag ternary and the flag gate around ProgressBarWithLabel), and unconditionally render the Deployment Load from Location button/modal.",
};

// unable to add type to launchDarklyConfig as the type needs to be inherited when making union type of keys (FlagKey type below)
const launchDarklyConfig = {
  "kacp-22367-deployment-enhancements": kacp22367DeploymentEnhancements,
};

// create a union type of all of the flags
type ObjectKeysUnion<T> = keyof T;

export type FlagKey = ObjectKeysUnion<typeof launchDarklyConfig>;

export default launchDarklyConfig;
